module.exports = __webpack_public_path__ + "img/douranovo.2569e31c.png";